export const featureFlag = {
  changeFacilitySearch: true,
  globalSearch: false,
  psnAlertGrid: false,
  watchList: true,
  recent: false,
  notificationSettings: true,
  rrDashboardFilter: false,
  includeLastWeekAndMonthDashboardFilter: false,
  appUpdateModal: false,
  bedExitMotionGraphSettings:
    "bed_exit_prob.ma(5).thr(>0.85).cooldown(40).ds_hour_sum.agg_hourly_mean",
  rtSettingsEmailList: [
    "stefan@circadia.health",
    "zach@circadia.health",
    "touqeer_cip@circadia.health",
    "umer@circadia.health",
    "umer_cip@circadia.com",
    "abdullah_ghaznavi@circadia.health",
    "daniel.bowen@circadia.health",
  ],
  modelNameColumnAllowlist: [
    "umer@circadia.health",
    "james@circadia.health",
  ] as const,
  atRiskReviewLockBypassEmailList: [
    "henry@circadia.health",
    "rachel.jorgensen@circadia.health",
    "yi+np@circadia.health",
    "kaitlyn@circadia.health",
  ] as const,
};
